import { useState, useRef, useEffect } from 'react'
import { useLanguage } from '../context/LanguageContext'

const APP_LANGUAGES = [
  { key: 'tigrinya', label: 'ትግርኛ', short: 'ትግ' },
  { key: 'amharic', label: 'አማርኛ', short: 'አማ' },
  { key: 'latin', label: 'English', short: 'EN' },
]

export default function LanguageSelector() {
  const { language, setLanguage, toggleLanguages, appLanguage, changeAppLanguage, t } = useLanguage()
  const [showPicker, setShowPicker] = useState(false)
  const pickerRef = useRef(null)

  // Close picker when clicking outside
  useEffect(() => {
    if (!showPicker) return
    function handleClick(e) {
      if (pickerRef.current && !pickerRef.current.contains(e.target)) {
        setShowPicker(false)
      }
    }
    document.addEventListener('mousedown', handleClick)
    return () => document.removeEventListener('mousedown', handleClick)
  }, [showPicker])

  const currentLang = APP_LANGUAGES.find(l => l.key === appLanguage) || APP_LANGUAGES[0]

  return (
    <div className="language-selector-wrap">
      {/* Text toggle: native ↔ latin (only when not latin app) */}
      {toggleLanguages.length > 1 && (
        <div className="language-selector">
          {toggleLanguages.map((lang) => (
            <button
              key={lang.key}
              className={`lang-btn ${language === lang.key ? 'active' : ''}`}
              onClick={() => setLanguage(lang.key)}
            >
              {lang.key === 'latin' ? t('langToggleLatin') : t('langToggleNative')}
            </button>
          ))}
        </div>
      )}

      {/* App language switcher */}
      <div className="app-lang-picker" ref={pickerRef}>
        <button
          className="app-lang-btn"
          onClick={() => setShowPicker(!showPicker)}
          title={t('langPickerTitle')}
          aria-label={t('langPickerTitle')}
          aria-expanded={showPicker}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"/>
            <line x1="2" y1="12" x2="22" y2="12"/>
            <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
          </svg>
          <span className="app-lang-current">{currentLang.label} ▾</span>
        </button>

        {showPicker && (
          <div className="app-lang-dropdown">
            {APP_LANGUAGES.map(lang => (
              <button
                key={lang.key}
                className={`app-lang-option ${appLanguage === lang.key ? 'active' : ''}`}
                onClick={() => {
                  changeAppLanguage(lang.key)
                  setShowPicker(false)
                }}
              >
                {lang.label}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
